export const VIEWPORTS = {
  verySmall: 356,
  small: 376,
  smallMedium: 576,
  medium: 768,
  mediumLarge: 992,
  large: 1200,
  veryLarge: 1400,
  heightMediumLarge: 800
};
